
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mexico-import-duty/chapter/[index]",
      function () {
        return require("private-next-pages/mexico-import-duty/chapter/[index].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mexico-import-duty/chapter/[index]"])
      });
    }
  